import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PurchaseCancel.module.css';

const PurchaseCancel = () => {
  return (
    <div className={styles.container}>
      <h1>購入がキャンセルされました</h1>
      <p>チケットの購入手続きがキャンセルされました。</p>
      <p>必要に応じて、再度チケットを選択してください。</p>

      <Link to="/" className={styles.button}>
        ホームに戻る
      </Link>
    </div>
  );
};

export default PurchaseCancel;
